import { getElectronStores } from './electronStores';
import { getSharedStores, resetSharedStores } from './shared';

export type SharedStateStores = ReturnType<typeof getSharedStores>;
export type ElectronStateStores = ReturnType<typeof getElectronStores>;

let currentSharedStoreTarget = 'ipc';
let currentSharedStores: SharedStateStores;
export const getStateStore = (target: string): SharedStateStores => {
  if (target === currentSharedStoreTarget && currentSharedStores) {
    return currentSharedStores;
  }
  if (currentSharedStores) {
    resetSharedStores(false);
  }
  currentSharedStoreTarget = target;
  currentSharedStores = getSharedStores();
  return currentSharedStores;
};

export const destroyAllSharedStores = (destroyListeners?: boolean, exceptions?: string[]) => {
  resetSharedStores(destroyListeners, exceptions);
  currentSharedStores = undefined as any;
};
